import { useTranslation } from '@gimlite/common';
import { WizardItemType, Zone } from '@gimlite/ui-v1';
import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ContractSubPoolLine } from '../../../../composition/line/contract-sub-pool.line';
import { ContractWizardInfos } from '../../../../composition/wizard-infos/contract.wizard-infos';
import { ConfirmationForm } from '../../../../form/confirmation/confirmation.form';
import { CreateNewSubPoolContractContext } from '../../createNewSubPoolContract.wizard';

export const ConfirmationStep = ({
  context: { contractBase, informations },
  validate,
  submit,
}: WizardItemType.Config.Component<CreateNewSubPoolContractContext>) => {
  const { t, lang } = useTranslation();

  const [allFeatures, setAllFeatures] = useState<JSX.Element[]>([]);

  useEffect(() => {
    const features: JSX.Element[] = [];

    features.push(
      <ContractSubPoolLine
        data={{
          name1: informations.name1 as string,
          name2: informations.name2,
          code: t('willBeGenerated'),
          status: contractBase.state ? 'ACTIVE' : 'SUSPENDED',
        }}
        config={{ action: false }}
      />,
    );

    setAllFeatures(features);
  }, [lang]);

  return (
    <Zone
      config={{
        gap: {
          y: 1,
          x: 1,
        },
        zones: [['info', 'list']],
        rows: ['1fr'],
        columns: ['min-content', '1fr'],
      }}
    >
      <Zone.Area config={{ area: 'info' }}>
        <ContractWizardInfos
          data={{
            APBMode: contractBase.APBMode,
            APBNext:
              contractBase.APBMode !== 'NONE' ? contractBase.APBNext : null,
            state: contractBase.state,
            startDate: contractBase.startDate,
            endDate: contractBase.endDate,
            description: contractBase.description,
            reference: contractBase.reference,
            articleCode: contractBase.articleCode,
          }}
        />
      </Zone.Area>

      <Zone.Area config={{ area: 'list' }}>
        <ConfirmationForm
          data={{
            list: allFeatures.map((node) => {
              return {
                _id: uuidv4(),
                items: {
                  component: node,
                },
              };
            }),
          }}
        />
      </Zone.Area>
    </Zone>
  );
};
